module.exports = __webpack_public_path__ + "img/bg-img2-home.694caf22.png";